import React, { useEffect, useState } from "react";
import "./infobar.scss";
import {
  Sidebar
} from "react-pro-sidebar";
import { BiChevronLeft, BiCopy, BiDownload } from "react-icons/bi";
import { RiDeleteBin7Line } from "react-icons/ri";
import { BsShare } from "react-icons/bs";
import { MdVisibility } from "react-icons/md";
import { TbLockAccess } from "react-icons/tb";
import { Dialog } from '@mui/material';
import moment from "moment";
import { notify } from "../../utils/services/notification";
import { deleteFileKey, getDealIDs } from "../../utils/services/lighthouse";
import Skeleton from "react-loading-skeleton";
import { Tooltip } from "react-tooltip";
import { getFileIcon } from "../../utils/services/fileTypeIcons";
import { bytesToString } from "../../utils/services/other";
import History from "../../utils/services/GlobalNavigation/navigationHistory";
import { DeleteFileDialog,FileShareDialog } from "../../dialogs";

interface InfoBarData {
  fileName: string;
  encryption: string;
  fileSizeInBytes: number;
  createdAt: string;
  cid: string;
}

function viewFile(data: any) {
  if (data.encryption === "false" || !data.encryption) {
    window.open(
      "https://gateway.lighthouse.storage/ipfs/" + data.cid,
      "_blank"
    );
  } else {
    if (History) {
      History?.navigate(`viewFile/${data.cid}`, { state: data });
    }
  }
}

const copyToClipboard = (text: string, isEncrypted: boolean) => {
  navigator.clipboard.writeText(
    isEncrypted ?
      `https://files.lighthouse.storage/viewFile/${text}` : `https://gateway.lighthouse.storage/ipfs/${text}`
  );
  notify("Copied To Clipboard", "success");
};

function downloadFile(cid: string, filename: string) {
  const url = `https://gateway.lighthouse.storage/ipfs/${cid}`;
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    })
    .catch(console.error);
}
async function deleteFile(cid: string, data: any) {
  await deleteFileKey(data.id);
  console.log(data);
}

interface InfobarProps {
  infoBarData: InfoBarData | null;
  setInfoBarData: any;
}

const Infobar: React.FC<InfobarProps> = ({ infoBarData, setInfoBarData }) => {
  const [shareDialogData, setShareDialogData] = useState<InfoBarData | null>(
    null
  );
  const [dealIDs, setDealIds] = useState<string | any[] | null>(null);
  const [deleteConfirmationDialog, setDeleteConfirmationDialog] = useState<boolean>(false);

  useEffect(() => {
    setDealIds(null);

    (async () => {
      try {
        const dealIds = infoBarData?.cid && (await getDealIDs(infoBarData?.cid));
        if (dealIds) {
          setDealIds(dealIds?.length > 6 ? dealIds.slice(0, 6) : dealIds);
        } else {
          setDealIds("CID push to miners in progress");
        }
      } catch (error) {
        setDealIds("CID push to miners in progress");
      }
    })();
  }, [infoBarData]);

  return (
    <Sidebar
      className="infoBarContainer"
      collapsed={infoBarData?.cid ? false : true}
      collapsedWidth="0px"
      width="270px"
    >
      <section
        className="ptr pro-sidebar-header"
        onClick={() => {
          setInfoBarData(null);
        }}
      >
        <BiChevronLeft />
        <p className="fileName">{"File Details"}</p>
      </section>
      <section className="pro-sidebar-layout">
        <div className="sidebarContainer">
          <div className="sidebarContainer__titleBox"  onClick={() => viewFile(infoBarData)}>
            <div className="iconBox">
              {getFileIcon(
                infoBarData?.fileName ? infoBarData?.fileName : "",
                infoBarData?.encryption === "true" || infoBarData?.encryption
                  ? true
                  : false
              )}
            </div>
            <p>{infoBarData?.fileName}</p>

          </div>
        
          <div className="sidebarContainer__propertiesBox">
            <p className="title">Properties</p>
            <table>
              <tbody>
                <tr>
                  <td>Size</td>
                  <td>{bytesToString(infoBarData?.fileSizeInBytes || 0)}</td>
                </tr>
                <tr>
                  <td>Created At</td>
                  <td>
                    {moment(infoBarData?.createdAt).format("DD-MM-YYYY")} <br />{" "}
                    {moment(infoBarData?.createdAt).format("h:mm:ss")}
                  </td>
                </tr>
                <tr>
                  <td>CID</td>
                  <td>{infoBarData?.cid}</td>
                </tr>
                <tr>
                  <td>Sharable URL</td>
                  <td > <a
  href={`https://gateway.lighthouse.storage/ipfs/${infoBarData?.cid}`}
  target="_blank"
  rel="noopener noreferrer"
>{`https://gateway.lighthouse.storage/ipfs/${infoBarData?.cid}`}</a></td>
                </tr>
                <tr></tr>
                <tr>
                  <td>Storage Deals</td>
                  <td>
                    {" "}
                    {Array.isArray(dealIDs)
                      ? dealIDs?.map((deal, index) => (
                        <span
                          className="link"
                          key={index}
                          onClick={() => {
                            window
                              .open(
                                `https://filfox.info/en/deal/${deal}`,
                                "_blank"
                              )
                              ?.focus();
                          }}
                        >
                          {deal}
                          {index + 1 === dealIDs.length ? "" : ","}&nbsp;
                        </span>
                      ))
                      : dealIDs || <Skeleton />}
                  </td>
                </tr>
                <tr>
                  <td>Actions</td>
                  <td>
                    <span
                      data-tooltip-id="tooltip"
                      data-tooltip-content="Copy Link"
                      onClick={() => {
                        copyToClipboard(infoBarData?.cid || '', !!infoBarData?.encryption)
                      }}
                    >
                      <BiCopy />
                    </span>
                    &nbsp;
                    {infoBarData?.encryption && (
                      <span
                        data-tooltip-id="tooltip"
                        data-tooltip-content="Share File"
                        onClick={() => {
                          setShareDialogData(infoBarData);
                        }}
                      >
                        <BsShare />
                      </span>
                    )}
                    &nbsp;
                    <span
                      data-tooltip-id="tooltip"
                      data-tooltip-content="Download File"
                      onClick={() =>
                        downloadFile(
                          infoBarData?.cid || "",
                          infoBarData?.fileName || ""
                        )
                      }
                    >
                      <BiDownload />
                    </span>
                    &nbsp;
                    <span
                      data-tooltip-id="tooltip"
                      data-tooltip-content="Delete File"
                      onClick={() =>
                        setDeleteConfirmationDialog(true)
                      }
                    ><RiDeleteBin7Line /></span>
                    &nbsp;
                    {infoBarData?.encryption && (
                      <span
                        data-tooltip-id="tooltip"
                        data-tooltip-content="Access Control"
                        onClick={() => {
                          History.navigate(
                            `dashboard/accessControl/${infoBarData?.cid}`,
                            {
                              state: infoBarData,
                            }
                          );
                        }}
                      >
                        <TbLockAccess />
                      </span>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <Dialog
        open={shareDialogData != null ? true : false}
        onClose={() => {
          setShareDialogData(null);
        }}
      >
        <FileShareDialog
          shareDialogData={shareDialogData}
          setShareDialogData={setShareDialogData}
        />
      </Dialog>
      <Dialog
        open={deleteConfirmationDialog}
        onClose={() => {
          setDeleteConfirmationDialog(false);
        }}
      >
        <DeleteFileDialog
          setDeleteConfirmationDialog={setDeleteConfirmationDialog}
          fileData={infoBarData}
        />
      </Dialog>

      <Tooltip id="tooltip" />
    </Sidebar>
  );
};

export default Infobar;
